import React, { useEffect, useState } from 'react';
import { func, object } from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import template from 'url-template';

import { isEmpty } from 'lodash';
import queryString from 'query-string';

import { getActiveTabName } from '../../containers/Dashboard/Navigation/NavigationHelper';

import * as BobActions from '../../actions/bobActions';

import classes from './Breadcrumb.module.css';

const entityUrl = template.parse('entities?appId={appId}&company={companyId}&parentId={parentId}&childId={childId}');
const companyUrl = template.parse('company?company={companyId}&appId={appId}&parentId={parentId}&childId={childId}');
const clientUrl = template.parse('client?client={clientId}&company={companyId}&appId={appId}&parentId={parentId}&childId={childId}');
const siteUrl = template.parse('site?client={clientId}&company={companyId}&site={siteId}&appId={appId}&parentId={parentId}&childId={childId}');
const equipmentUrl = template.parse('equipment?client={clientId}&company={companyId}&equipment={equipmentId}&site={siteId}&appId={appId}&parentId={parentId}&childId={childId}viewChildId={viewChildId}');

const navType = {
    'company':     0,
    'application': 1,
    'client':      2,
    'site':        3,
    'equipment':   4,
};

const Breadcrumb = ({
    activeNavCompany,
    activeNavClient,
    activeNavSite,
    activeNavEquipment,
    fetchNavClients,
    fetchNavSites,
    fetchNavEquipment,
    history,
    resetNavOptions,
    setActiveNavClient,
    setActiveNavEquipment,
    setActiveNavSite,
    setNavClient,
    setNavCompany,
    setNavEquipment,
    setNavSite,
    targetNavCompany,
    targetNavClient,
    targetNavSite,
    targetNavEquipment,
    ...props
}) => {
    const [application, setApplication] = useState({});
    const [company, setCompany] = useState({});
    const [client, setClient] = useState({});
    const [site, setSite] = useState({});
    const [equipment, setEquipment] = useState({});
    const [system, setSystem] = useState({});

    const queryValues = queryString.parse(history.location.search);

    useEffect(() => {
        return () => {
            setSystem({});
        };
    }, []);

    useEffect(() => {
        setSystem(props.system);
    }, [props.system]);

    useEffect(() => {
        setApplication({ name: getActiveTabName(queryValues.appId) });
    }, [queryValues.appId]);

    useEffect(() => {
        if (Object.keys(company).length === 0 && history.location.search.indexOf('company=') > -1) {
            setCompany(activeNavCompany);

            return;
        }
    }, [activeNavCompany]);

    useEffect(() => {
        if (Object.keys(client).length === 0 && history.location.search.indexOf('client=') > -1) {
            setClient(activeNavClient);

            return;
        }
    }, [activeNavClient]);

    useEffect(() => {
        if (Object.keys(site).length === 0 && history.location.search.indexOf('site=') > -1) {
            setSite(activeNavSite);

            return;
        }
    }, [activeNavSite]);

    useEffect(() => {
        if (Object.keys(equipment).length === 0 && history.location.search.indexOf('equipment=') > -1) {
            setEquipment(activeNavEquipment);

            return;
        }
    }, [activeNavEquipment]);

    useEffect(() => {
        const init = async () => {
            if (!isEmpty(activeNavCompany)) {
                if (targetNavCompany.id !== activeNavCompany.id) {
                    await fetchNavClients(activeNavCompany.id);
                }

                setCompany(activeNavCompany);
                setNavCompany(activeNavCompany);
            }

            if (!isEmpty(activeNavClient)) {
                if (targetNavClient.id !== activeNavClient.id) {
                    await fetchNavSites(activeNavClient.id);
                }

                setClient(activeNavClient);
                setNavClient(activeNavClient);
            } else {
                setClient({});
                setNavClient({});
            }

            if (!isEmpty(activeNavSite)) {
                if (targetNavSite.id !== activeNavSite.id) {
                    await fetchNavEquipment(activeNavSite.id);
                }

                setSite(activeNavSite);
                setNavSite(activeNavSite);
            } else {
                setSite({});
                setNavSite({});
            }

            if (!isEmpty(activeNavEquipment)) {
                setEquipment(activeNavEquipment);
                setNavEquipment(activeNavEquipment);
            } else {
                setEquipment({});
                setNavEquipment({});
            }
        };

        init();
    }, [history.location.search]);

    let breadcrumb = [company, application, client, site, equipment, system ];

    const getUrl = (index) => {
        let url = '';

        if (history.location.pathname === '/v2/dashboard/equipment/sensor' || history.location.pathname === '/v2/dashboard/system/sensor') {
            url = '../';
        }

        if (getActiveTabName() === 'K2A Core') {
            return;
        }

        if (index === navType.company) {
            return '';
        } else if (index === navType.application) {
            if (queryValues.appId === '1710345b-cf28-4a02-9bf4-df9209ff29cb') {
                url = url + entityUrl.expand({
                    companyId: company.id,
                    appId:     '1710345b-cf28-4a02-9bf4-df9209ff29cb',
                    parentId:  '7e71f5d4-9fbf-4710-8601-e1f11e681479',
                    childId:   '231b3d07-1afb-42a0-b6ff-ecb9c4dd8c48'
                });
            } else {
                url = url + companyUrl.expand({
                    companyId: company.id,
                    appId:     'ad356bf2-b9db-4bb5-922e-c3394b1a63e3',
                    parentId:  'ad356bf2-b9db-4bb5-922e-c3394b1a63e4',
                    childId:   'ccb00d85-7b0c-44ba-bd0e-db216ef1ee46'
                });
            }

            return url;
        } else if (index === navType.client) {
            if (queryValues.appId === '1710345b-cf28-4a02-9bf4-df9209ff29cb') {
                url = url + entityUrl.expand({
                    companyId: company.id,
                    appId:     '1710345b-cf28-4a02-9bf4-df9209ff29cb',
                    parentId:  '3ee59a8f-d13a-475b-b424-ee55eef98a65',
                    childId:   'e979b520-3695-422d-a914-ba55c51fb316'
                });
            } else {
                url = url + clientUrl.expand({
                    companyId: company.id,
                    clientId:  client.id,
                    appId:     'ad356bf2-b9db-4bb5-922e-c3394b1a63e3',
                    parentId:  'a73c8c70-35aa-48b7-a797-4c607ae25280',
                    childId:   'f6ba2344-ba47-42c5-a98b-978365ca3936'

                });
            }

            return url;
        } else if (index === navType.site) {
            if (queryValues.appId === '1710345b-cf28-4a02-9bf4-df9209ff29cb') {
                let updatedUrl = history.location.search.replace(/[?&]equipment=[^&]+/, '').replace(/^&/, '?');
                updatedUrl = updatedUrl.replace(/[?&]system=[^&]+/, '').replace(/^&/, '?');
                return updatedUrl;
            }
            url = url + siteUrl.expand({
                companyId: company.id,
                clientId:  client.id,
                siteId:    site.id,
                appId:     'ad356bf2-b9db-4bb5-922e-c3394b1a63e3',
                parentId:  'c0c505f5-c7fc-4317-8cb6-f6e631142a77',
                childId:   'bb5be75b-d466-48d5-99da-79cd66504f20'
            });
            return url;
        } else if (index === navType.equipment) {
            if (queryValues.appId === '1710345b-cf28-4a02-9bf4-df9209ff29cb') {
                let updatedUrl = history.location.search.replace(/[?&]system=[^&]+/, '').replace(/^&/, '?');
                return updatedUrl;
            }
            url = url + equipmentUrl.expand({
                companyId:   company.id,
                clientId:    client.id,
                siteId:      site.id,
                equipmentId: equipment.id,
                appId:       'ad356bf2-b9db-4bb5-922e-c3394b1a63e3',
                parentId:    '7a88bd3d-64e3-4af9-aa06-9a31533df83c',
                childId:     '4b25aeb8-75d4-4522-9f77-870ab40abb07',
                viewChildId: '4b25aeb8-77d4-4522-9f77-870ab40abb07'
            });
            return url;
        }
        return '/dashboard';
    };

    const reset = (index) => {
        if (index === navType.application) {
            resetNavOptions('client');

            setActiveNavClient({});
            setActiveNavSite({});
            setActiveNavEquipment({});

            setNavClient({});
            setNavSite({});
            setNavEquipment({});

            setSystem({});
        } else if (index === navType.client) {
            resetNavOptions('site');

            setActiveNavSite({});
            setActiveNavEquipment({});

            setNavSite({});
            setNavEquipment({});
            setSite({});
            setSystem({});
        } else if (index === navType.site) {
            setActiveNavEquipment({});

            setNavEquipment({});

            setSystem({});
        }
    };

    const renderBreadcrumbItem = (object, index) => {
        if (object && object.name) {
            return <span className={classes.breadcrumbItem} key={index}>
                <Link 
                    to={getUrl(index)} 
                    onClick={
                        (e) => {
                            if (!e.ctrlKey) {
                                reset(index);
                            }
                        }
                    }
                >
                    {object.name}
                </Link>
                <span className={classes.breadcrumbArrow}>{'>'}</span>
            </span>;
        }
        return null;
    };

    return (

        <React.Fragment>
            <div className={classes.Breadcrumb}>
                {breadcrumb.map((br, i) => (
                    renderBreadcrumbItem(br, i)
                ))}
            </div>
        </React.Fragment>
    );
};

Breadcrumb.defaultProps = {
    activeNavCompany:   {},
    activeNavClient:    {},
    activeNavSite:      {},
    activeNavEquipment: {},
    resetNavOptions:    () => {},
    setNavClient:       () => {},
    setNavCompany:      () => {},
    setNavEquipment:    () => {},
    setNavSite:         () => {},
    targetNavCompany:   {},
    targetNavClient:    {},
    targetNavSite:      {},
    targetNavEquipment: {}
};

Breadcrumb.propTypes = {
    activeNavCompany:   object,
    activeNavClient:    object,
    activeNavSite:      object,
    activeNavEquipment: object,
    resetNavOptions:    func,
    setNavClient:       func,
    setNavCompany:      func,
    setNavEquipment:    func,
    setNavSite:         func,
    targetNavCompany:   object,
    targetNavClient:    object,
    targetNavSite:      object,
    targetNavEquipment: object
};

const mapStateToProps = state => {

    return {
        activeNavCompany:   state.bob.activeNavCompany,
        activeNavClient:    state.bob.activeNavClient,
        activeNavSite:      state.bob.activeNavSite,
        activeNavEquipment: state.bob.activeNavEquipment,
        targetNavCompany:   state.bob.targetNavCompany,
        targetNavClient:    state.bob.targetNavClient,
        targetNavSite:      state.bob.targetNavSite,
        targetNavEquipment: state.bob.targetNavEquipment
    };
};

const mapDispatchToProps = {
    ...BobActions
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Breadcrumb));
